module.exports = __webpack_public_path__ + "img/banner-1.23800a3c.jpg";